// Module
var code = "<a aria-label=\"{{ 'general_captions-help' | translate }}\" class=\"tertiary-btn light\" ng-href=\"{{ $ctrl.helpUrls.captions }}\" target=\"{{ $ctrl.helpUrls.target }}\" translate=\"general_captions-help\"></a>";
// Exports
module.exports = code;